<template>
	<MainTempComp
		ref="mainTempRef"
		:searchOption="data.searchOption"
		:handleSearch="handleSearch"
	>
		<template #header>
			<span style="padding-left: 10px"></span>
			<el-button type="primary" @click="handleSearch">查询</el-button>
<!--			<el-button type="primary" @click="handleAddOwner"
				>新增业主</el-button
			>
			<el-button type="primary" @click="handleAddWasher"
				>新增洗手</el-button
			>-->
		</template>
		<template #main>
			<tableComp :tableData="data.tableData"></tableComp>
		</template>
	</MainTempComp>
	<add-edit-user
		ref="AddEditUserRef"
		:currentData="data.currentData"
	></add-edit-user>
</template>

<script>
import { onMounted, provide, reactive, ref } from "vue";
import tableComp from "./table.vue";
import { apiUserInfoList } from "@/api/requestApis.js";
import AddEditUser from "./children/add-edit-user.vue";
export default {
	name: "userManage",
	components: {
		tableComp,

		AddEditUser,
	},
	setup() {
		const mainTempRef = ref(null);
		const AddEditUserRef = ref(null);

		const data = reactive({
			tableData: [],
			currentData: {},
			searchOption: [
				{
					name: "姓名",
					type: "input",
					key: "name",
					value: "",
				},
				{
					name: "手机号",
					type: "input",
					key: "phone",
					value: "",
				},
				{
					name: "用户类型",
					type: "select",
					key: "userType",
					value: "",
					options: [
						{
							label: "业主",
							value: 1,
						},
						{
							label: "洗手",
							value: 2,
						},
						{
							label: "车主",
							value: 3,
						},
					],
				},
			],
		});
		const handleSearch = async () => {
			data.tableData = [];
			const res = await apiUserInfoList({
				size: mainTempRef.value.pageSize,
				current: mainTempRef.value.currentPage,
				...mainTempRef.value.searchParams,
			});
			mainTempRef.value.setTotalValue(res && res.total);
			data.tableData = res.list || [];
		};
		const handleAddOwner = () => {
			data.currentData = { userType: 1 };
			AddEditUserRef.value.handleToggle(true);
		};
		const handleAddWasher = () => {
			data.currentData = { userType: 2 };
			AddEditUserRef.value.handleToggle(true);
		};

		const handleUpdateTable = () => {
			handleSearch();
		};
		provide("handleUpdateTable", handleUpdateTable);
		provide("handleSearch", handleSearch);

		onMounted(() => {
			handleSearch();
		});
		return {
			AddEditUserRef,
			handleAddWasher,
			handleAddOwner,
			mainTempRef,
			data,
			handleSearch,
		};
	},
};
</script>

<style scoped>
</style>
